import { useEffect, useRef } from "react";

/**
 * useScrollAnimation
 * Attaches an IntersectionObserver to the returned ref.
 * When the element enters the viewport it adds "is-visible" to every
 * child that has the class "animate-on-scroll".
 */
const useScrollAnimation = (threshold = 0.15) => {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const targets = el.querySelectorAll(".animate-on-scroll");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            targets.forEach((t) => t.classList.add("is-visible"));
            observer.unobserve(el); // fire once
          }
        });
      },
      { threshold }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [threshold]);

  return ref;
};

export default useScrollAnimation;
